import { createSlice } from '@reduxjs/toolkit';

import { TYPE_ALL } from '../../../common/constants/label';

export const nameSpace = 'DEEP_SEARCH';

const initialState = {
  isLoading: false,
  targetTagId: '',
  filterBy: TYPE_ALL,
  selectedItemId: null,
  isIncludeAllTags: false,
  deepSearchTabIsAvailable: false,
  deepQuery: '',
  data: [],
  describe: [],
  videoTags: [],
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'deepSearch',
  initialState,
  reducers: {
    deepSearchSetValueAction: (state, action) => {
      state.deepQuery = action.payload;
    },
    deepSearchClearResultAction: (state) => {
      state.selectedItemId = null;
      state.data = [];
      state.describe = [];
      state.videoTags = [];
      state.isLoading = true;
    },
    deepSearchSetLoadingStateAction: (state, action) => {
      state.isLoading = action.payload;
    },
    deepSearchIncludeAllTagsToggleAction: (state, action) => {
      state.selectedItemId = null;
      state.isIncludeAllTags = action.payload;
    },
    deepSearchFetchStartedAction: (state) => state,
    deepSearchFetchErrorAction: (state) => {
      state.isLoading = false;
    },
    deepSearchFetchSuccessAction: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key];
      });

      state.isLoading = false;
    },
    deepSearchToggleTagsResultAction: (state, action) => {
      state.selectedItemId = null;
      state.describe = state.describe.map((item) => ({
        ...item,
        disabled: action.payload === item.id ? !item.disabled : item.disabled,
      }));
    },
    deepSearchSetFilterByAction: (state, action) => {
      state.selectedItemId = null;
      state.filterBy = action.payload;
    },
    deepSearchSetSelectedTagAction: (state, action) => {
      state.selectedItemId = action.payload;
    },
    deepSearchSetTargetTagAction: (state, action) => {
      state.targetTagId = action.payload;
    },
    deepSearchResetToDefaultAction: () => initialState,
    deepSearchIsAvailableAction: (state, action) => {
      state.deepSearchTabIsAvailable = action.payload;
    },
  },
});

export const {
  deepSearchSetValueAction,
  deepSearchClearResultAction,
  deepSearchFetchErrorAction,
  deepSearchFetchSuccessAction,
  deepSearchIncludeAllTagsToggleAction,
  deepSearchResetToDefaultAction,
  deepSearchSetFilterByAction,
  deepSearchSetLoadingStateAction,
  deepSearchSetSelectedTagAction,
  deepSearchSetTargetTagAction,
  deepSearchToggleTagsResultAction,
  deepSearchFetchStartedAction,
  deepSearchIsAvailableAction,
} = slice.actions;
